import axios from "axios";

const state = {
    images: [],
    status: "idle"
}

const getters = {
    images: (state) => state.images,
    status: (state) => state.setStatus
}

const actions = {
    async loadImg({ commit, rootState }, image) {
        try {
            commit("setStatus", "loading");
            if (!image.hasOwnProperty("id") || image.id === null || image.id === undefined) {
                console.log("Invalid Image ID found in Image Module");
                return;
            }

            //if(state.images.find(img => img.id === image.id) !== false) return; 

            //determine if a format is used
            const format = image.format !== undefined ? `/?key=${image.format}` : "";

            //construct the url
            const url = rootState.app.assets + image.id + format;

            //build header
            const header = rootState.auth.authHeader();
            header.responseType = "blob";
            header.method = "get";

            //process respone and genereate URL
            const response = await axios.get(url, header);
            const imgBlob = response.data;
            const blobUrl = URL.createObjectURL(imgBlob);

            //prepare image to add to state.images
            const loadedImage = {
                id: image.id,
                url: blobUrl,
                mode: image.mode,
                volatile: image.volatile,
                format: image.format
            }

            commit("addImage", loadedImage);
        } catch (error) {
            console.log(error);
            throw "Error loading Images";
        } finally {
            commit("setStatus", "idle");
        }
    },
    async getImgURL({dispatch, commit}, image) {
        try {
            commit("setStatus", "loading");
            const alreadyLoaded = state.images.find(img => img.id === image.id && img.format === image.format);
            if(typeof alreadyLoaded !== "undefined") return alreadyLoaded;
            await dispatch("loadImg", image);   
                   
            return state.images.find(img => img.id === image.id && img.format === image.format);            
        } catch(error) {
            console.log(error);
            throw "Error fetching blob URL";
        } finally {
            commit("setStatus", "idle");
        }
    },
    async unloadImg({ commit }, id) {
        try {
            const imageToUnload = state.images.filter(img => { return img.id === id });
            if (!imageToUnload) {
                console.log("Could not find Image to Unload.");
                return;
            }
            URL.revokeObjectURL(imageToUnload.url);
        } catch (error) {
            console.log(error);
            throw "Error unloading Image " + id;
        } finally {
            commit("setStatus", "idle");
        }
    },
    async clearImages({ dispatch, commit }) {
        if (state.images.length === 0) return;
        for (let i = 0; i < state.images.length; i++) {
            if (state.images[i].volatile) {
                await dispatch("unloadImg", state.images[i].id);
            }
        }
        commit("clearImages");
    },
    async insertImageURLs(_, refs) {
        for (let ref in refs) {
            if (ref.indexOf("image-") > -1) {
                if (ref.split("image-")[1] === undefined || refs[ref] == "undefined" || (Array.isArray(refs[ref]) && refs[ref].length) === 0 ) continue;
                const imgId = ref.split("image-")[1];
                const imgNode = Array.isArray(refs[ref]) ? refs[ref][0]: refs[ref];
                if(!imgNode) continue;
                const format = imgNode.dataset.format;
                const mode = imgNode.dataset.mode;

                const imgReference = state.images.find(imgref => imgref.id === imgId && imgref.mode == mode && imgref.format == format);

                if (imgReference !== false && typeof imgReference != "undefined") {
                    if (imgReference.mode === "bg") imgNode.style.backgroundImage = `url('${imgReference.url}')`;
                    if (imgReference.mode !== "bg") imgNode.src = imgReference.url;
                }
            }
        }
    },
    async loadImageBatch({ dispatch }, imagesToLoad) {        
        for (let ref in imagesToLoad) {
            if (ref.indexOf("image-") > -1) {

                //check if valid
                if (ref.split("image-")[1] === undefined 
                || imagesToLoad[ref] === undefined 
                || (Array.isArray(imagesToLoad[ref]) && imagesToLoad[ref].length) === 0) 
                {
                    continue;
                }

                //get the stuff we need and check if its an array or node reference, get values accordingly
                const id = ref.split("image-")[1];
                const format = typeof imagesToLoad[ref].dataset != "undefined" ? imagesToLoad[ref].dataset.format : imagesToLoad[ref][0].dataset.format;
                const mode = typeof imagesToLoad[ref].dataset != "undefined" ? imagesToLoad[ref].dataset.mode : imagesToLoad[ref][0].dataset.mode;
                const volatile = typeof imagesToLoad[ref].dataset != "undefined" ? imagesToLoad[ref].dataset.volatile : imagesToLoad[ref][0].dataset.volatile

                //check if already loaded 
                const exists = state.images.filter(img => img.id === id && img.format === format && img.mode === mode);
                if(exists.length) continue;

                //build the payload for the load method
                const imgPayload = {
                    id,
                    format,
                    mode,
                    volatile 
                }

                //dispatch load 
                await dispatch("loadImg", imgPayload);
            }
        }
    }
}

const mutations = {
    addImage: (state, image) => state.images.push(image),
    rmImage: (state, idx) => state.images.splice(idx, 1),
    setStatus: (state, newStatus) => state.status = newStatus,
    clearImages: (state) => state.images.splice(0)
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}